/**
 * El administrador escribe colones; la API y D1 conservan céntimos.
 *
 * El estado del campo guarda solo dígitos para que el separador de miles sea
 * presentación, no parte del valor. Así «73,450» siempre viaja como 7345000,
 * un número entero, y nunca como el texto que antes provocaba errores o como
 * un monto cien veces menor.
 */
export function colonDigits(raw: string): string {
  return raw.replace(/\D/g, '').replace(/^0+(?=\d)/, '').slice(0, 12);
}

export function formatColonDigits(digits: string): string {
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function colonDigitsToMinor(digits: string): number | null {
  if (!/^\d+$/.test(digits)) return null;
  const minor = Number(digits) * 100;
  return Number.isSafeInteger(minor) && minor > 0 ? minor : null;
}

export function minorToColonDigits(minor: number): string {
  return String(Math.max(0, Math.round(minor / 100)));
}
